'use client';

var __jsx = React.createElement;
import { cn } from '@lib/cn';
import React from 'react';
const IconButton = _ref => {
  let {
    icon,
    onClickButton = () => {},
    className = '',
    disabled = false
  } = _ref;
  const handleClick = event => {
    if (!disabled) {
      event.preventDefault();
      onClickButton();
    }
  };
  return __jsx("div", {
    onClick: handleClick,
    className: cn({
      'cursor-pointer': !disabled
    }, className)
  }, icon);
};
export default IconButton;